import { Flex, Box, Text, Badge, Avatar } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { InboxItem } from 'src/api/inboxes';
import { dayjs } from 'src/libs/dayjs';

type InboxMessageProps = {
  message: InboxItem;
};

export const InboxMessage = (props: InboxMessageProps) => {
  const { message } = props;
  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center" gap={2}>
          {message.originator.type === 'user' ? (
            <Avatar
              w="28px"
              h="28px"
              name={message.originator.name}
              src={message.originator.avatar}
            />
          ) : (
            <Box
              borderRadius="full"
              w="28px"
              h="28px"
              border="1px"
              borderColor="border.subtle"
              display="flex"
              alignItems="center"
              justifyContent="center">
              <Icon iconName="logo" boxSize={4} />
            </Box>
          )}
          <Flex direction="column">
            <Text
              fontFamily="marketingPage"
              fontWeight="medium"
              color="text.title">
              {message.originator.name}
            </Text>
            <Text fontFamily="marketingPage" color="text.title" opacity={0.6}>
              {message.originator.userId}
            </Text>
          </Flex>
        </Flex>
        <Text fontFamily="marketingPage" fontWeight="normal" color="text.title">
          {dayjs(message.date).format('MMM D, YYYY, hh:mm A')}
        </Text>
      </Flex>
      <Flex direction="column">
        <Flex direction="column">
          <Box>
            {message.isSystem && (
              <Badge
                bg="background.green.200"
                color="icon.green"
                px={3}
                py={1}
                variant="subtle"
                rounded="full"
                fontWeight="bold">
                system
              </Badge>
            )}
          </Box>
          <Text
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize={32}
            color="text.title">
            {message.title}
          </Text>
        </Flex>
        <Text
          display="flex"
          fontFamily="marketingPage"
          fontSize={14}
          my={6}
          color="text.title">
          {message.description}
        </Text>
      </Flex>
    </>
  );
};
